module.exports = __webpack_public_path__ + "img/3.359547f9.jpg";